/* assets/ai-config.js */
window.ART_CONFIG = window.ART_CONFIG || {};

(function() {
    const _registry = {
        "blessing": {
            "product": { "sku": "blessing", "name": "Blessing Art" },
            "assets": {
                "templates": [                    
                    "https://cdn.shopify.com/s/files/1/0677/1117/2800/files/model_11.jpg?v=1785197875",
                    "https://cdn.shopify.com/s/files/1/0677/1117/2800/files/model_10.jpg?v=1784945132"
                ],
                "canvasBg": "https://cdn.shopify.com/s/files/1/0677/1117/2800/files/frame-color_1.jpg?v=1784042691"
            },
            "ai": { 
                "style": "bless", 
                "sku1": "blessing", 
                "sku2": "default_model", 
                "options": { "useMask": true, "imageScale": 1.0 } 
            },
            "ui": { "frameLabel": "Add floating frame" },
            "wallPreview":{

                "shape":"square",

                "defaultSize":"20x20",

                "defaultFrame":"white",

                "enabled":true

                },
                
            "customInput":{

                "enabled":true,

                "required":false,


                "title":"Add a Name or Blessing",


                "description":
                "Add a name or blessing message to personalize your artwork.",



                "fields":{


                    "name":{


                        "enabled":true,


                        "label":"Name",


                        "placeholder":"Enter name"

                    },



                    "date":{


                        "enabled":false


                    },



                    "message":{


                        "enabled":true,


                        "label":"Blessing Message",


                        "placeholder":"Example: God Bless You Always"


                    }


                }


            }
            
        },
        "bless-bodhi": {
            "product": { "sku": "bless-bodhi", "name": "Blessing Art - Walk With Jesus" },
            "assets": {
                "templates": [
                    "https://cdn.shopify.com/s/files/1/0677/1117/2800/files/model_4.jpg?v=1784176510"
                ],
                "canvasBg": "https://cdn.shopify.com/s/files/1/0677/1117/2800/files/frame-color_1.jpg?v=1784042691"
            },
            "ai": { 
                "style": "bless", 
                "sku1": "bless-bodhi", 
                "sku2": "default_model", 
                "options": { "useMask": true, "imageScale": 1.0 } 
            },
            "ui": { "frameLabel": "Add floating frame" },
            "wallPreview":{

                "shape":"square",

                "defaultSize":"20x20",

                "defaultFrame":"white",

                "enabled":true

                },
            "customInput":{

                "enabled":true,

                "required":false,


                "title":"Add a Name or Blessing",


                "description":
                "Add a name or blessing message to personalize your artwork.",



                "fields":{


                    "name":{


                        "enabled":true,


                        "label":"Name",


                        "placeholder":"Enter name"

                    },



                    "date":{


                        "enabled":false


                    },



                    "message":{


                        "enabled":true,


                        "label":"Blessing Message",


                        "placeholder":"Example: God Bless You Always"


                    }


                }


            }
            
        },
        "bless-divine": {
            "product": { "sku": "bless-divine", "name": "Blessing Art - Guardian on Your Path" },
            "assets": {
                "templates": [
                    "https://cdn.shopify.com/s/files/1/0677/1117/2800/files/model_2.jpg?v=1784176367"
                ],
                "canvasBg": "https://cdn.shopify.com/s/files/1/0677/1117/2800/files/frame-color_1.jpg?v=1784042691"
            },
            "ai": { 
                "style": "bless", 
                "sku1": "bless-divine", 
                "sku2": "default_model", 
                "options": { "useMask": true, "imageScale": 1.0 } 
            },
            "ui": { "frameLabel": "Add floating frame" },
            "wallPreview":{

                "shape":"square",

                "defaultSize":"20x20",

                "defaultFrame":"white",

                "enabled":true

                }
            
        },
        "bless-bridge": {
            "product": { "sku": "bless-bridge", "name": "Blessing Art - Guardian on the Bridge" },
            "assets": {
                "templates": [
                    "https://cdn.shopify.com/s/files/1/0677/1117/2800/files/model.png?v=1784176317"
                ],
                "canvasBg": "https://cdn.shopify.com/s/files/1/0677/1117/2800/files/frame-color_1.jpg?v=1784042691"
            },
            "ai": { 
                "style": "bless", 
                "sku1": "bless-bridge", 
                "sku2": "default_model", 
                "options": { "useMask": true, "imageScale": 1.0 } 
            },
            "ui": { "frameLabel": "Add floating frame" },
            "wallPreview":{

                "shape":"square",

                "defaultSize":"20x20",

                "defaultFrame":"white",

                "enabled":true

                }
            
        },
        "bless-family": {
            "product": { "sku": "bless-family", "name": "Blessing Art - Christian Couple Blessing" },
            "assets": {
                "templates": [
                    "https://cdn.shopify.com/s/files/1/0677/1117/2800/files/model_5.jpg?v=1784176057"
                ],
                "canvasBg": "https://cdn.shopify.com/s/files/1/0677/1117/2800/files/frame-color_1.jpg?v=1784042691"
            },
            "ai": { 
                "style": "bless", 
                "sku1": "bless-family", 
                "sku2": "default_model", 
                "options": { "useMask": true, "imageScale": 1.0 } 
            },
            "ui": { "frameLabel": "Add floating frame" },
            "wallPreview":{

                "shape":"square",

                "defaultSize":"20x20",

                "defaultFrame":"white",

                "enabled":true

                }
            
        },
         "bless-communion": {
            "product": { "sku": "bless-communion", "name": "Blessing Art - Divine First Communion" },
            "assets": {
                "templates": [
                    "https://cdn.shopify.com/s/files/1/0677/1117/2800/files/model_1.jpg?v=1784176014"
                ],
                "canvasBg": "https://cdn.shopify.com/s/files/1/0677/1117/2800/files/frame-color_1.jpg?v=1784042691"
            },
            "ai": { 
                "style": "bless", 
                "sku1": "bless-communion", 
                "sku2": "default_model", 
                "options": { "useMask": true, "imageScale": 1.0 } 
            },
            "ui": { "frameLabel": "Add floating frame" },
            "wallPreview":{

                "shape":"square",

                "defaultSize":"20x20",

                "defaultFrame":"white",

                "enabled":true

                }
            
        },
        "bless-HeavenReunion": {
            "product": { "sku": "bless-HeavenReunion", "name": "Blessing Art - Heaven Reunion" },
            "assets": {
                "templates": [
                    "https://cdn.shopify.com/s/files/1/0677/1117/2800/files/model.jpg?v=1784181812"
                ],
                "canvasBg": "https://cdn.shopify.com/s/files/1/0677/1117/2800/files/frame-color_1.jpg?v=1784042691"
            },
            "ai": { 
                "style": "bless", 
                "sku1": "bless-HeavenReunion", 
                "sku2": "default_model", 
                "options": { "useMask": true, "imageScale": 1.0 } 
            },
            "ui": { "frameLabel": "Add floating frame" },
            "wallPreview":{

                "shape":"square",

                "defaultSize":"20x20",

                "defaultFrame":"white",

                "enabled":true

                }
            
        },
        "bless-PetHeavenReunion": {
            "product": { "sku": "bless-PetHeavenReunion", "name": "Blessing Art -Pet Heaven Reunion" },
            "assets": {
                "templates": [
                    "https://cdn.shopify.com/s/files/1/0677/1117/2800/files/model_2.png?v=17841866902"
                ],
                "canvasBg": "https://cdn.shopify.com/s/files/1/0677/1117/2800/files/frame-color_1.jpg?v=1784042691"
            },
            "ai": { 
                "style": "bless", 
                "sku1": "bless-PetHeavenReunion", 
                "sku2": "default_model", 
                "options": { "useMask": true, "imageScale": 1.0 } 
            },
            "ui": { "frameLabel": "Add floating frame" },
            "wallPreview":{

                "shape":"square",

                "defaultSize":"20x20",

                "defaultFrame":"white",

                "enabled":true

                }
            
        },
        "bless-OldmanHeaven": {
            "product": { "sku": "bless-OldmanHeaven", "name": "Blessing Art -Pet Heaven Reunion" },
            "assets": {
                "templates": [
                    "https://cdn.shopify.com/s/files/1/0677/1117/2800/files/model_9.jpg?v=1784263059"
                ],
                "canvasBg": "https://cdn.shopify.com/s/files/1/0677/1117/2800/files/frame-color_1.jpg?v=1784042691"
            },
            "ai": { 
                "style": "bless", 
                "sku1": "bless-OldmanHeaven", 
                "sku2": "default_model", 
                "options": { "useMask": true, "imageScale": 1.0 } 
            },
            "ui": { "frameLabel": "Add floating frame" },
            "wallPreview":{

                "shape":"square",

                "defaultSize":"20x20",

                "defaultFrame":"white",

                "enabled":true

                },
            "customInput":{

                "enabled":true,

                "required":true,


                "title":"Personalize Your Memorial",


                "description":
                "The following text will be printed on your artwork.",


                "fields":{

                    "name":{

                        "enabled":true,

                        "label":"Angel Name",

                        "placeholder":"Enter name"

                    },


                    "date":{

                        "enabled":true,

                        "label":"Memorial Year",

                        "placeholder":"1940 - 2012"

                    },


                    "message":{

                        "enabled":false

                    }

                }

            }
            
        },
        "Flowers-blessing": {
            "product": { "sku": "Flowers-blessing", "name": "Blessing Art - Flowers" },
            "assets": {
                "templates": [                    
                    "https://cdn.shopify.com/s/files/1/0677/1117/2800/files/model_12.jpg?v=1785511570"
                ],
                "canvasBg": "https://cdn.shopify.com/s/files/1/0677/1117/2800/files/frame-color_1.jpg?v=1784042691"
            },
            "ai": { 
                "style": "bless", 
                "sku1": "Flowers-blessing", 
                "sku2": "default_model", 
                "options": { "useMask": true, "imageScale": 1.0 } 
            },
            "ui": { "frameLabel": "Add floating frame" },
            "wallPreview":{

                "shape":"square",

                "defaultSize":"20x20",

                "defaultFrame":"white",

                "enabled":true

                },
                
            "customInput":{

                "enabled":true,

                "required":false,


                "title":"Add a Name or Blessing",


                "description":
                "Add a name or blessing message to personalize your artwork.",



                "fields":{


                    "name":{


                        "enabled":true,


                        "label":"Name",


                        "placeholder":"Enter name"

                    },



                    "date":{


                        "enabled":false


                    },



                    "message":{


                        "enabled":true,


                        "label":"Blessing Message",


                        "placeholder":"Example: God Bless You Always"


                    }


                }


            }
            
        },
        "oldman-blessing": {
            "product": { "sku": "oldman-blessing", "name": "old man Blessing Art" },
            "assets": {
                "templates": ["https://cdn.shopify.com/s/files/1/0677/1117/2800/files/pet_1.jpg"],
                "canvasBg": "https://cdn.shopify.com/s/files/1/0677/1117/2800/files/frame_2.jpg"
            },
            "ai": { 
                "style": "bless", 
                "sku1": "oldman-blessing", 
                "sku2": "pet_v1", 
                "options": { "useMask": false, "imageScale": 1.2 } 
            },
            "ui": { "frameLabel": "Add pet frame" },
            "wallPreview":{

                "enabled":true,

                "shape":"rectangle",

                "defaultSize":"30x20",

             "defaultFrame":"wood"

            }
        }
    };
    

    const _cache = new Map();

    window.ART_CONFIG.get = (sku) => {
        if (_cache.has(sku)) return _cache.get(sku);
        if (!_registry[sku]) {
            console.error(`[AI Config Error] SKU "${sku}" not found.`);
            return null;
        }
        _cache.set(sku, _registry[sku]);
        return _registry[sku];
    };
})();